{
  "formName": "Credit Note Form",
  "formRows": [
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "creditNoteDate",
            "displayLabel": "Date",
            "disabled": false,
            "fieldInfo": {
              "dataType": "date"
            },
            "validators": [
              {
                "type": "required",
                "message": "Date is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "invoiceId",
            "displayLabel": "Invoice No",
            "disabled": false,
            "placeHolder": "Select Invoice No",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/invoices/list",
                "filterByKeys": ["INVOICE_NO_CONTAINS"],
                "limit": 10,
                "orderBy": {"invoiceNo": "asc"},
                "bindLabel": "invoiceNo",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "invoiceNo",
                    "header": "Invoice Number"
                  },
                  {
                    "key": "invoiceType",
                    "header": "Invoice Type"
                  },
                  {
                    "key": "status",
                    "header": "Status"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Invoice No. is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "customerId",
            "displayLabel": "Customer",
            "disabled": false,
            "placeHolder": "Select Customer",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "select",
              "options": [],
              "displayKey": "label",
              "valueKey": "value"
            },
            "conditions": {
              "disabled": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "invoiceId",
                    "operator": "EQUALS",
                    "value": null
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Customer is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "chargeId",
            "displayLabel": "Charge",
            "disabled": false,
            "placeHolder": "Select Charge",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "select",
              "options": [],
              "displayKey": "label",
              "valueKey": "value"
            },
            "conditions": {
              "disabled": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "invoiceId",
                    "operator": "EQUALS",
                    "value": null
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Document Type is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "amount",
            "displayLabel": "Amount",
            "disabled": false,
            "placeHolder": "Enter Amount",
            "fieldInfo": {
              "dataType": "number"
            },
            "validators": [
              {
                "type": "required",
                "message": "Amount is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 6"
          },
          "control": {
            "label": "description",
            "displayLabel": "Remarks",
            "disabled": false,
            "placeHolder": "Enter Description",
            "fieldInfo": {
              "dataType": "textarea"
            },
            "validators": [
              {
                "type": "required",
                "message": "Description is required"
              }
            ]
          }
        }
      ]
    }
  ]
}
